import React, { useEffect, useState } from "react";

import { tw } from "@careinfo/tailwind";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  createAccount,
  createAccountInfovalidation,
} from "../../../../validation/AccountInfo";
import AccountInfoForm from "./AccountInfoForm";
import Button from "../../../Reusable/Button";

const CreateAccountPopup = (props: any) => {
  const { handleCreateAccount, isLoading, setOpenAccountPopup } = props;
  const [isactive, setIsActive] = useState("credit");
  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(createAccount),
    defaultValues: {
      parent: {
        id: "407cc0e0-383d-4b06-92bd-3bcb98ae43af",
        account_full_name: "Assets-Current Assets-Bank",
      },
    },
  });

  useEffect(() => {
    setValue("balance_type", isactive);
  }, [isactive]);

  return (
    <form
      onSubmit={handleSubmit((data) =>
        handleCreateAccount(data, setOpenAccountPopup, setError)
      )}
      className={tw`max-w-2xl`}
      autoComplete="off"
    >
      <AccountInfoForm
        control={control}
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
        isactive={isactive}
        setIsActive={setIsActive}
      />
      <div className={tw`mt-4 w-full px-4 `}>
        <div className={tw`w-32 ml-auto`}>
          <Button label="Create" isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateAccountPopup;
